// SD-5: the dialog's field is called Carrier for both the carrier and the driver.
export const DELIVERY_ASSIGNEE_REQUIRED_MESSAGE = 'Carrier is required.';
//# sourceMappingURL=delivery-assignee-required-message.js.map